import React from 'react'

import classNames from './AdvancedForm.css'
import ConfirmButtons from '../ConfirmButtons'

export default function AdvancedForm ({ value, onChange, onCancel, updateTerm, pristine }) {
  const input = (key, label) => (
    <label>
      {label}
      <input
        type='text'
        value={value[key] || ''}
        onChange={e => onChange({
          ...value,
          [key]: e.target.value || undefined
        })}
        className={classNames.advancedInput}
      />
    </label>
  )
  return (
    <div className={classNames.form}>
      {input('filename', 'Filename')}
      {input('transmissionReference', 'Transmission Reference')}
      {input('orientation', 'Orientation (1-8)')}
      <ConfirmButtons
        onCancel={onCancel}
        confirmText='Submit'
        onConfirm={() => updateTerm({ type: 'other', value })}
        confirmDisabled={pristine}
      />
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/search/AdvancedForm.js